import React from 'react';
import { FastProfitLogo } from './FastProfitLogo';
export function Footer() {
  return <footer className="bg-brand-navy pt-16 pb-24 md:pb-16 border-t border-brand-gold/20" data-id="element-69">
      <div className="container mx-auto px-4 flex flex-col items-center text-center" data-id="element-70">
        <FastProfitLogo size="md" className="mb-10 opacity-80 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-71" />

        <div className="w-full max-w-2xl h-[1px] bg-brand-gold/30 mb-8" data-id="element-72"></div>

        <div className="font-body text-gray-400 text-sm mb-6 flex flex-col md:flex-row gap-2 md:gap-4 justify-center items-center" data-id="element-73">
          <span data-id="element-74">© 2026 Bigger Profits. All Rights Reserved.</span>
          <span className="hidden md:inline" data-id="element-75">|</span>
          <div className="flex gap-4" data-id="element-76">
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-77">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-78">
              Terms of Service
            </a>
          </div>
        </div>

        <p className="font-body text-gray-500 text-xs italic max-w-4xl leading-relaxed" data-id="element-79">
          This site is not a part of Google™ website or network of sites such
          as Youtube™ or any company owned by Google™ or Youtube™.
          Additionally this website is not endorsed by Google™ Youtube™ or
          Facebook Inc. in any way. Google™ is a trademark for all their
          respective companies, FACEBOOK™ is a trademark of FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}